<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <!--
      <div class="desc" style='display: flex; margin-right: 30px;'>
        <span class="label-tit" style='width: 100px' >출고구분</span>
        <b-select class="select " v-model="form.inType">
          <option value='' label="선택">선택</option>
          <option
            v-for="item in combos['inType']"
            :key="item.key"
            :value="item.key"
            v-text="item.value"/>
        </b-select>
        <span class="label-tit" style='width: 100px' >지역/센터</span>
        <b-select class="select " v-model="form.catId" @change="onCatIdChange">
          <option value='' label="선택">선택</option>
          <option
              v-for="item in combos['catId']"
              :key="item.key"
              :value="item.key"
              v-text="item.value"/>
        </b-select>
        <b-select class="select " v-model="form.subCatId" v-show="changeCatIdShow">
          <option value='' label="선택">전체</option>
          <option
              v-for="item in combos['subCatId']"
              :key="item.key"
              :value="item.key"
              v-text="item.value"/>
        </b-select>
      </div>
-->
      <div class="btn-type1" style="">
        <button class="btn-size btn-gray btn-space" @click="save()">
        <span class="btn-icon">
            <i class="fas fa-save"></i>
        </span>
          출고저장
        </button>
        <button class="btn-size btn-gray" @click="goSearch()">
        <span class="btn-icon">
            <i class="fas fa-search"></i>
        </span>
          검색
        </button>
      </div>
      <div class="pop-content-search">
        <el-form size="mini" @submit.prevent>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="출고구분" label-width="100px">
                <el-select v-model="saveForm.inType" @change="onInTypeChange">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['inType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" >
              <el-form-item label="지역/센터" label-width="120px">
                <el-col :span="12">
                  <el-select :disabled="catIdDisabled" v-model="saveForm.catId" @change="onCatIdChange">
                    <el-option value='' label="선택">선택</el-option>
                    <el-option
                        v-for="item in combos['catId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select :disabled="catIdDisabled" v-model="saveForm.subCatId" v-show="changeCatIdShow">
                    <el-option value='' label="선택">선택</el-option>
                    <el-option
                        v-for="item in combos['subCatId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="출고일자" label-width="120px">
                    <el-date-picker type="date" placeholder="Pick a date" v-model="saveForm.outDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="pop-content-search">
        <el-form size="mini" @submit.prevent>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="제조사" label-width="60px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" style="margin-left:-40px;">
              <el-row>
                <el-form-item label="제품군" label-width="120px">
                  <el-col :span="12">
                    <el-select v-model="form.itemGroup" @change="onItemGroupChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['itemGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="form.subItemGroup" v-show="changeItemGroupShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subItemGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-form-item label="품번" label-width="60px">
                <el-input v-model="form.itemCd"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="grid-wrap">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                style="width: 100%; height: 330px;"
                class="ag-theme-alpine"
                :framework-components="frameworkComponents"
                :column-defs="columnDefs"
                :grid-options="gridOptions"
                :row-data="rowData"
                :default-col-def="defaultColDef"
                :enableRangeSelection="true"
                :stopEditingWhenCellsLoseFocus="true"
                @cell-value-changed="onCellValueChanged"
                @grid-ready="onGridReady"/>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>


<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';
import mixin from "@/mixin/lucoms";

import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";


function _url(...args) {
  args = args.map(x => String(x || '').trim().replace(/^\/*|\/*$/g, ''))
  args = args.filter(x => x)
  return args.join('/')
}


export default {
  mixins: [mixin],
  props: {
    data: {
      Type: Object
      , required: false
    },
  },
  components: {Layout, AgGridVue},
  data() {
    return {
      title: '자재출고추가등록',
      saveForm:{
        inType : '',
        catId : '',
        subCatId : '',
        outDt : this.$moment().format('YYYY-MM-DD')
      },
      form: {
        companyId : 'CENTERLINK',
        maker : '',              // 제조사
        catId : '',              // 지역
        subCatId: '',            // 지역 상세
        itemGroup : '',          // 제품군
        description : '',
        useModelNm : '',
        itemCd : '',             // 품번
        asAgentId : '',
        subItemGroup: '',        // 제품군 상세
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : '',
        inType: '',              //출고구분
      },
      combos: {
        'maker' : [],
        'catId' : [],            // 지역센터
        'subCatId' : [],         // 지역 상세
        'itemGroup' : [],        // 제품군
        'subItemGroup' : [],     // 제품군 상세
        'inType' : [],           // 출고구분
      },
      // AG-GRID OPTION [START]
      rowData:[],
      rowDataOrg:[], /** 조회후 데이타 백업 */
      gridOptions: {},
      frameworkComponents : {
        checkBox: CheckboxCellRenderer,
      },
      columnDefs:[
      ],
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      statusBar: null,
      changeCatIdShow : false,
      changeItemGroupShow : false,
      catIdDisabled : false,
      editableTxtGoodQty : true,
      editableTxtBadQty : true,
      // AG-GRID OPTION [END]
    }
  },
  mounted() {
    this.getCombo()
    this.getConfigValue()
  },
  destroyed() {
    //ModalSlot open z-index change
    //$('.lnb').css('z-index', '7');
  },
  methods: {
    changeTab(params) {
      this.viewer = params.tabId;
    },
    closeModal() {
      console.log(this.$parent)
      this.$parent.close();
    },
    handleNodeClick(data) {
      console.log(data);
    },
    onGridReady(){
      this.createColumnDefs();
    },
    getCombo() {
      this.getMakerCombo();
      this.getItemGroupCombo();
      this.getInTypeCombo();
      this.getCatIdCombo();
    },
    getConfigValue() {
      this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
          .then(response => {
            this.form.asAgentId = response.data[0].configValue;
          });
    },
    getMakerCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 196} })
          .then(response => {
            this.combos['maker'] = response.data || []
          });
    },
    getItemGroupCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 143} })
          .then(response => {
            this.combos['itemGroup'] = response.data || []
          });
    },
    getInTypeCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 294} })
          .then(response => {
            this.combos['inType'] = response.data.filter(x=>x.key !== 'Order') || []
          });
    },
    getCatIdCombo(){
      this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
          .then(response => {
            this.combos['catId'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    onItemGroupChange(param){
      this.form.subItemGroup = '';
      if(param === '' ) this.changeItemGroupShow =  false;
      else{
        this.changeItemGroupShow =  true;
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subItemGroup'] = response.data || []
                  });
            });
      }
    },
    onInTypeChange(param){
      if(param === 'Erp') {
        this.catIdDisabled = true
        this.saveForm.catId = '';        // 지역센터
        this.saveForm.subCatId = '';     // 지역 상세
        this.editableTxtBadQty = true;   // 불량출고
      } else {
        this.editableTxtBadQty = false;  // 불량출고
        this.catIdDisabled = false
      }
      this.goSearch();
    },
    goSearch(){
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/mateStock/list"), {
        companyId : this.form.companyId,
        maker : this.form.maker,               // 제조사
        itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,          // 제품군
        subItemGroup: '',                      // 제품군 상세
        useModelNm : this.form.useModelNm,     //
        itemCd : this.form.itemCd,             // 품번
        catId : 0,
        asAgentId : this.form.asAgentId,
        description : this.form.description,
        sortType : this.form.sortType,         // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      }).then(response => {
            this.rowData = response.data.map(x => {
              x.asIsGoodQty = x.goodQty
              x.asIsBadQty = x.badQty
              x.goodQty = 0
              x.badQty = 0
              return x
            })
          }).finally(() => {
            this.$store.commit('finish')
      });
//          })
    },
    save() {
      let vm = this;
      if(vm.saveForm.inType === '' || vm.saveForm.inType === null || vm.saveForm.inType === undefined){
        this.$swal({type: 'warning', text: '출고구분을 선택해 주십시오.'});
        return false;
      }

      if(vm.saveForm.inType !== 'Erp' && (vm.saveForm.catId === '' || vm.saveForm.catId === null || vm.saveForm.catId === undefined)){
        this.$swal({type: 'warning', text: '센터를 선택해 주십시오.'});
        return false;
      }

      let list = this.rowData.filter(v => v.chk === 'Y');
      vm.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 저장 하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then(r => {
          if (r.value) {
            vm.$store.commit('loading')
            vm.result = list;

            for(let i=0; i<vm.result.length; i++){
              Object.assign(vm.result[i]
                  , { inType: vm.saveForm.inType }
                  , { outAsAgentId: this.$store.state.loginInfo.asAgentId }
                  , { productType: "Item"}
                  , { outType: vm.saveForm.inType}
                  , { outDt: vm.saveForm.outDt + 'T00:00:00'}
                  , { description: ''}
                  , { inAsAgentId : (vm.saveForm.subCatId.length <= 0 || vm.saveForm.subCatId === '')  ? (vm.saveForm.catId === '' ? 0 : vm.saveForm.catId) : vm.saveForm.subCatId }
                  , { outItemId: 0});
            }

            // _.forEach(this.result, node => {
            //   if (node.goodQty <= 0 ) {
            //     this.$store.commit('finish')
            //     this.$swal({ type: 'info', text: '품명 : ' + node.itemNm + ' 의 양품출고 수량은 0 보다 커야합니다.' });
            //     return false;
            //   }
            // })

            for (const node of this.result) {
              if (node.goodQty <= 0) {
                this.$store.commit('finish');
                this.$swal({ type: 'info', text: '품명 : ' + node.itemNm + ' 의 양품출고 수량은 0 보다 커야합니다.' });
                return;
              }
            }

            this.$http.post(_url(`/api/workMng/mateDelivery/save`), vm.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '자재출고 추가 저장을 했습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goSearch();
                      }
                    });
              })
              .catch((e) => {
                this.$swal({ type: 'success', text: '자재출고 추가 저장을 실패 했습니다.' })
              })
              .finally(() => {
                vm.$store.commit('finish')
              });
          }
        }).catch((e) => {
        })
      } else {
        this.$swal({ type: 'info', text: '저장할 항목을 선택하세요.' });
      }
    },
    createColumnDefs() {
      const vm = this
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'제조사', field:'makerNm', width:130, cellStyle : {textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:130, cellStyle : {textAlign: 'center'}},
        {headerName:'품번', field:'itemCd', width:150, cellStyle : {textAlign: 'left'}},
        {headerName:'품명', field:'itemNm', width:180, cellStyle : {textAlign: 'left'}},
        {headerName:'양품재고', field:'asIsGoodQty', width:110, cellStyle : {textAlign: 'right'},
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }},
        {headerName:'양품출고', field:'goodQty', width:110,
          cellStyle:(params) => {
            if(vm.saveForm.inType === 'Erp'){
              return  (params.data.asIsGoodQty > 0) ? {textAlign: 'right', backgroundColor: '#fff8f7'} : {textAlign: 'right'}
            } else if(vm.saveForm.inType === 'BsMa' || vm.saveForm.inType === 'Agent'){
              return  (params.data.asIsGoodQty != 0) ? {textAlign: 'right', backgroundColor: '#fff8f7'} : {textAlign: 'right'}
            } else {
              return true
            }
          },
          editable: (params) => {
            if(vm.saveForm.inType === 'Erp' || vm.saveForm.inType === 'BsMa' || vm.saveForm.inType === 'Agent'){
              return  (params.data.asIsGoodQty > 0 ) ? true : false
            } else {
              return false
            }
          },
          valueFormatter: (params) => {
            vm.cellEditingQty(params);
            return vm.getNumberFormat(params.value);
          }},
        {headerName:'불량재고', field:'asIsBadQty', width:110, cellStyle : {textAlign: 'right'},
          valueFormatter: (params) => {
          return vm.getNumberFormat(params.value);
        }},
        {headerName:'불량출고', field:'badQty', width:110,
          cellStyle:(params) => {
            if(vm.saveForm.inType === 'Erp'){
              return  (params.data.asIsBadQty > 0) ? {textAlign: 'right', backgroundColor: '#fff8f7'} : {textAlign: 'right'}
            }
          },
          editable: (params) => {
            if(this.editableTxtBadQty && params.data.asIsBadQty > 0){
              return true
            }else{
              return false
            }
          },
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }},
        {headerName:'선택', field: 'chk', width: 80, cellRenderer: 'checkBox',
          cellRendererParams: (params) => {
            function chkDisable(params) {
              if(vm.saveForm.inType === 'Erp'){
                return  (params.data.asIsGoodQty > 0 || params.data.asIsBadQty > 0) ? false : true
              } else if(vm.saveForm.inType === 'BsMa' || vm.saveForm.inType === 'Agent'){
                return  (params.data.asIsGoodQty != 0) ? false : true
              } else {
                return true
              }
            }
            return {trueValue: 'Y', falseValue: 'N', disable: chkDisable(params) }
          }}
      ];
    },
    onCellValueChanged(params) {
      if (params.colDef.field === "goodQty") {
        const newValue = params.newValue;
        const rowIndex = params.rowIndex;
        const newData = this.rowData[rowIndex];
        if(newData.asIsGoodQty < parseInt(newValue)){
          this.$swal({ type: 'info', text: '출고 수량이 현재고수량보다 많을 수 없습니다.' });
          newData.goodQty = 0
          this.$set(this.rowData, rowIndex, newData);
        }
      } else if (params.colDef.field === "badQty"){
        const newValue = params.newValue;
        const rowIndex = params.rowIndex;
        const newData = this.rowData[rowIndex];
        if(newData.asIsBadQty < parseInt(newValue)){
          this.$swal({ type: 'info', text: '출고 수량이 현재고수량보다 많을 수 없습니다.' });
          newData.badQty = 0
          this.$set(this.rowData, rowIndex, newData);
        }
      }
    },
    cellEditingQty(params) {
      if(params.data.goodQty > 0) {
        params.node.setDataValue('chk', 'Y');
      } else {
        params.data.goodQty = '0';
        params.node.setDataValue('chk', 'N');
      }
      this.createColumnDefs();
    },
  },
}

</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}

.btn-space {
  margin-right: 4px;
}
</style>